/** Router component */
import React, { Component, createRef } from "react";
import loadable from "@loadable/component";
import { Switch, Route, withRouter } from "react-router-dom";
import { hot } from "react-hot-loader/root";
import PublicRoute from "../services/router/pubicRoute";
import PrivateRoute from "../services/router/privateRoute";
import QuickBuyRoute from "../services/router/quickBuyRoute";
import ReedumptionRoute from "../services/router/reedumptionRoute";
import PreloginToPostloginConnector from "./pages/PreloginToPostloginConnector";
import PreloginToPostloginSignzyConnector from "./pages/PreloginToPostloginSignzyConnector";
import NewInvestorTxnFeedback from "./organism/thankyou/NewInvestorTxnFeedback";
import { registerServiceWorker } from "../helper/serviceWorkerHelper";
import { registerPushNotifications } from "../helper/notification";
import { SipProvider } from '../components/pages/SipHouse/SipContext';

// import SecureRoute from './organism/secureRoute';
// const Loading = () => <div>Loading...</div>
// import Header from '../components/header/header';
// import Footer from '../components/footer/footer';
const Unclaimed = loadable(() => import("./pages/unclaimed"));
const UnclaimedDashboard = loadable(() => import("./pages/unclaimed/dashboard"));
const Login = loadable(() => import("./pages/login"));
const PaymentDashboard = loadable(() => import("./pages/PaymentDashbord"));
const InvestOnline = loadable(() => import("./pages/login/investonline"));
const QuickLogin = loadable(() => import("./pages/quick-login"));
const NoMatch = loadable(() => import("./pages/nomatch"));
const SessionExpired = loadable(() => import("./pages/sessionExpired"));
const SomethingWentWrong = loadable(() => import("./pages/somethingWentWrong"));
const Dashboard = loadable(() => import("./pages/dashboard"));
const Prelogin = loadable(() => import("./pages/preloginPages/route"));
const About = loadable(() => import("./pages/preloginPages/aboutus"));
const Contact = loadable(() => import("./pages/preloginPages/contact/contact"));

const Tools = loadable(() => import("./pages/preloginPages/tools"));
const Nav = loadable(() => import("./pages/preloginPages/nav"));
const Business = loadable(() =>
  import("./pages/preloginPages/InternationalBusiness")
);
const AIFPage = loadable(() =>
  import("./pages/preloginPages/InternationalBusiness/aif")
);
const MFFund = loadable(() => import("./pages/preloginPages/landing/mf"));
const CategoryPage = loadable(() => import("./pages/preloginPages/category"));
const CategoryNew = loadable(() =>
  import("./pages/preloginPages/category/category")
);
const MFDetail = loadable(() =>
  import("./pages/preloginPages/listingPage/mflisting")
);
const Compare = loadable(() =>
  import("./pages/preloginPages/compare/comparefund")
);
const Faq = loadable(() => import("./pages/preloginPages/faq/faq"));
const PassiveFund = loadable(() =>
  import("./pages/preloginPages/landing/passivefund")
);
const EtfFund = loadable(() => import("./organism/landing/eft"));
const AccountStmt = loadable(() =>
  import("./pages/preloginPages/accountStatement")
);
const PMSDetail = loadable(() =>
  import("./pages/preloginPages/listingPage/pmsDetail")
);
const PMSBusiness = loadable(() =>
  import("./organism/listingPage/PMSbusinessportfolio")
);
const PMSNext = loadable(() =>
  import("./organism/listingPage/PMSNesttrillion")
);
const Indiastrategy = loadable(() =>
  import("./organism/listingPage/indiastrategy")
);
const IndiastrategyV2 = loadable(() =>
  import("./organism/listingPage/indiastrategyV2")
);

const PMS = loadable(() => import("./pages/preloginPages/landing/pms"));
const PassiveDetail = loadable(() =>
  import("./pages/preloginPages/listingPage/passiveDetail")
);
const PMSList = loadable(() =>
  import("./pages/preloginPages/category/pmslisting")
);
const Download = loadable(() => import("./pages/preloginPages/download"));
const Onboarding = loadable(() => import("./pages/Onboarding"));
const Schedule = loadable(() => import("./pages/schedule/sip"));
const KycNo = loadable(() => import("./pages/kyc/kycNo"));
const Home = loadable(() => import("./pages/home"));
const PaymentResp = loadable(() => import("./pages/transactionResponse"));
// const PaymentOLResp = loadable(() => import('./pages/transactionResponse/onlineResp'))
// const Profile = loadable(() => import('./pages/profile'));
const ManageBank = loadable(() => import("./pages/manageBank"));
const InvestmentCart = loadable(() => import("./pages/investmentCart"));
const PrivacyPolicy = loadable(() => import("./pages/tnc/privacyPolicy"));
const Disclaimer = loadable(() => import("./pages/tnc/disclaimer"));

// postlogin
// const NoMatch = loadable(() => import('./pages/nomatch'));
const Transasct = loadable(() => import("./pages/transact"));
const TransResponse = loadable(() => import("./pages/transactionResponse"));
const SystematicPlan = loadable(() => import("./pages/systematicPlan"));
const Reports = loadable(() => import("./pages/reports"));
const DashboardNew = loadable(() => import("./organism/Dashboard"));
const TrackOrder = loadable(() => import("./pages/trackorder"));
const Profile = loadable(() => import("./pages/profile"));
const OtpPreference = loadable(() => import("./pages/otpPreference"));
const RedeemThank = loadable(() => import("./organism/thankyou/redeemres"));
const Confirmation = loadable(() => import("./organism/thankyou/confirmation"));
const QuickBuyConfirmation = loadable(() =>
  import("./organism/thankyou/quickbuyConfirmation")
);
const QuickBuyWBConfirmation = loadable(() =>
  import("./organism/thankyouWB/quickbuyConfirmationWB")
);

const ScheduleSip = loadable(() => import("./organism/schedule/sip"));
const ScheduleStp = loadable(() => import("./organism/schedule/stp"));
const ScheduleSwp = loadable(() => import("./organism/schedule/swp"));
const Payment = loadable(() => import("./organism/payment/payment"));
const Cart = loadable(() => import("./organism/investmentCart"));
const CartNew = loadable(() => import("./organism/investmentCartNew"));
const ManageAc = loadable(() => import("./organism/manageAccount"));
const EmandateScreen = loadable(() => import("./organism/manageBank/Emandate"));
const PaymentOLResp = loadable(() =>
  import("./pages/transactionResponse/onlineResp")
);
const Intersistial = loadable(() => import("./pages/Onboarding/intersistial"));
const IntermediateBasket = loadable(() =>
  import("./pages/intermediate/basket")
);
const IntermediateCart = loadable(() => import("./pages/intermediate/cart"));
const Connect = loadable(() => import("./pages/connectus"));
const EmandateConfirmation = loadable(() =>
  import("./organism/thankyou/emandateConfirmation")
);

const Cashflow = loadable(() => import("./pages/html/cashflow"));
const Movipack = loadable(() => import("./pages/html/moviPresentation"));
const SIPbooster = loadable(() => import("./pages/html/sipbooster"));
const QuickBuy = loadable(() => import("./organism/categoryNew/quickroute"));
const QuickBuy2 = loadable(() => import("./organism/quickBuy2"));
const CartSlider = loadable(() =>
  import("./organism/categoryNew/cartSliderRoute")
);
const remuneration = loadable(() =>
  import("./pages/remuneration/remnew2")
);
const nomineeManage = loadable(() => import("./organism/manageBank/nominee"));
const addnominee = loadable(() => import("./organism/manageBank/addnominee"));
const mandatePopup = loadable(() => import("./pages/mandatePopUp"));
const FabPlan = loadable(() => import("./pages/fabPlan"));
const FabPlanConfirmation = loadable(() =>
  import("./pages/fabPlan/FabConfirmation")
);

const CancelRedemption = loadable(() => import("./pages/cancelRedumption"));
const RedemptionConfirmation = loadable(() => import("./pages/confirmation"));
//LAS
const LasDisclaimer = loadable(() => import("./pages/lasDisclaimer"));
const winBackPayment = loadable(() => import("./pages/winBackPayment"));
const SipHouse = loadable(() => import("./pages/SipHouse"));
const PaymentPage = loadable(() => import("./pages/SipHouse/PaymentSelection/PaymentMode"))
const ThankyouPage = loadable(() => import("./pages/SipHouse/ThankyouPage/Thankyou"))
// const NfoBasket = loadable(() => import("./pages/nfoBasket"))

// const loadClevertap = () => {
//   // const pathName = window.location.pathname === '/' ? '/home' : window.location.pathname;
//   const CLEVERTAP_ACCOUNT_ID =
//     process.env.NODE_ENV === "production" &&
//       window.location.hostname === "www.motilaloswalmf.com"
//       ? "69R-9Z9-686Z"
//       : "TEST-RK8-694-786Z";
//   const scriptTag = document.createElement("script");
//   scriptTag.id = "clevertap_script";
//   scriptTag.type = "text/javascript";
//   scriptTag.innerHTML = `var clevertap = {event:[], profile:[], account:[], onUserLogin:[], region:'in1', notifications:[], privacy:[]};
//   // replace with the CLEVERTAP_ACCOUNT_ID with the actual ACCOUNT ID value from your Dashboard -> Settings page
//   clevertap.account.push({"id": "${CLEVERTAP_ACCOUNT_ID}"});
//   clevertap.privacy.push({optOut: false}); //set the flag to true, if the user of the device opts out of sharing their data
//   clevertap.privacy.push({useIP: false}); //set the flag to true, if the user agrees to share their IP data
//   clevertap.notifications = { includePushId: true };
//   (function () {
//           var wzrk = document.createElement('script');
//           wzrk.type = 'text/javascript';
//           wzrk.async = true;
//           wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/clevertap.min.js';
//           var s = document.getElementsByTagName('script')[0];
//           s.parentNode.insertBefore(wzrk, s);
//   })();
//   clevertap.spa = true
//   window.clevertap = clevertap;`;
//   // clevertap.event.push('navigated_to: ${pathName}');
//   console.log('in loadClevertap');
//   document.head.appendChild(scriptTag);
// };

class Router extends Component {
  constructor(props) {
    super(props);
    this.tmr1 = createRef();
    this.tmr2 = createRef();
  }
  componentDidMount() {
    console.log('mounting components index');
    async function setupServiceWorker() {
      console.log('in setupServiceWorker');
      try {
        await registerServiceWorker();
        await registerPushNotifications();
      } catch (error) {
        console.log("setupServiceWorker", error);
      }
    }

    // this.tmr1.current = setTimeout(loadClevertap, 200);

    this.tmr2.current = setTimeout(setupServiceWorker, 4000);
  }

  componentWillUnmount() {
    clearTimeout(this.tmr1.current);
    clearTimeout(this.tmr2.current);
    console.log('unmounting components index');
  }

  render() {
    let quickbuyRout = false;
    console.log(this.props, "sujeet");
    if (typeof window !== "undefined") {
      let localItem = localStorage.getItem("CreateFolio");
      let parseData = JSON.parse(localItem);
      if (parseData !== null) {
        console.log("get Localstoreg", parseData);
        if (parseData.pageName === "quickbuy") {
          quickbuyRout = true;
        }
      }
    }

    console.log("get Localstoreg", quickbuyRout);

    return (
      <React.Fragment>
        {/* <Header /> */}

        <Switch>
          <PublicRoute restricted={false} component={Home} path="/" exact />
          <PublicRoute
            restricted={false}
            component={Cashflow}
            path="/cashflow"
            exact
          />
          <PublicRoute
            restricted={false}
            component={Movipack}
            path="/motilal-oswal-value-index"
            exact
          />
          <PublicRoute
            restricted={false}
            component={SIPbooster}
            path="/sip-booster"
            exact
          />
          {/* <PublicRoute restricted={false} component={PaymentOLResp} path="/paymentResponse" exact /> */}
          <PublicRoute restricted={false} component={Faq} path="/faq" />
          <PublicRoute restricted={false} component={KycNo} path="/KycNo" />
          <PublicRoute
            restricted={false}
            component={About}
            path="/about-us/:id"
          />
          <PublicRoute restricted={false} component={Contact} path="/Contact" />
          <PublicRoute restricted={false} component={Tools} path="/tools/:id" />
          <PublicRoute restricted={false} component={Nav} path="/Nav" />
          <PublicRoute
            restricted={false}
            component={Business}
            path="/InternationalBusiness"
          />
          <PublicRoute restricted={false} component={AIFPage} path="/AIF" />
          <PublicRoute restricted={false} component={MFFund} path="/mf" exact />
          {/* <PublicRoute restricted={false} component={CategoryPage} path="/mf/Category" /> */}
          <PublicRoute
            restricted={false}
            component={CategoryNew}
            path="/mutual-funds"
          />
          <PublicRoute
            restricted={false}
            component={CategoryNew}
            path="/index-funds"
          />
          <PublicRoute
            restricted={false}
            component={Compare}
            path="/mf/Compare"
          />
          <PublicRoute
            restricted={false}
            component={MFDetail}
            path="/our-funds/:id"
          />
          <PublicRoute
            restricted={false}
            component={PassiveFund}
            path="/indexfund"
          />
          <PublicRoute
            restricted={false}
            component={EtfFund}
            path="/etf-fund"
          />
          <PublicRoute
            restricted={false}
            component={PassiveDetail}
            path="/index-fund/:id"
          />
          <PublicRoute
            restricted={false}
            component={AccountStmt}
            path="/AccountStatement"
          />
          <PublicRoute
            restricted={false}
            component={PMSDetail}
            path="/pageDetail/:id"
          />
          <PublicRoute
            restricted={false}
            component={PMSBusiness}
            path="/PMSbusiness"
          />
          <PublicRoute restricted={false} component={PMSNext} path="/PMSNext" />
          <PublicRoute
            restricted={false}
            component={Indiastrategy}
            path="/Indiastrategy"
          />
          <PublicRoute
            restricted={false}
            component={IndiastrategyV2}
            path="/IndiastrategyV2"
          />

          <PublicRoute
            restricted={false}
            component={PMS}
            path="/portfolio-management-services"
          />
          <PublicRoute
            restricted={false}
            component={PMSList}
            path="/PMSListing"
          />
          <PublicRoute
            restricted={false}
            component={Download}
            path="/Download/:id/:id"
          />
          <PublicRoute
            restricted={false}
            component={InvestOnline}
            path="/login"
          />
          <PublicRoute
            restricted={false}
            component={QuickLogin}
            path="/partners-quicklogin"
          />

           <PublicRoute
            restricted={false}
            component={PaymentDashboard}
            path="/payment-dashboard"
            hideHeaderFooter={true}
          />
          {/* <PublicRoute restricted={false} component={InvestOnline} path="/investonline/:id" /> */}
          {/* <PublicRoute restricted={false} component={Onboarding} path="/onboarding/:id" /> */}
          {/* <PublicRoute restricted={false} component={Profile} path="/Profile" /> */}
          <PublicRoute
            restricted={false}
            component={Schedule}
            path="/schedule/:id"
          />
          {/* <PublicRoute restricted={false} component={ManageBank} path="/manage-account/:id" /> */}
          {/* <PublicRoute restricted={false} component={InvestmentCart} path="/Cart" /> */}
          <PublicRoute
            restricted={false}
            component={PrivacyPolicy}
            path="/privacy-policy"
          />
          <PublicRoute
            restricted={false}
            component={Disclaimer}
            path="/disclaimer"
          />
          <PublicRoute
            restricted={false}
            component={IntermediateBasket}
            path="/intermediateBasket"
          />
          {/* <PublicRoute restricted={false} component={QuickBuy} path="/investonline/mutualfund?returnUrl=/transact/quick-invest" /> */}
          <PublicRoute
            restricted={false}
            component={CartSlider}
            path="/mutualFund/cartSlider"
          />
          <PublicRoute
            restricted={false}
            component={IntermediateCart}
            path="/intermediateCart"
          />

          <PublicRoute
            restricted={false}
            component={mandatePopup}
            path="/mandatePopup"
          />

          <PublicRoute
            restricted={false}
            hideNavBarMenus={true}
            component={winBackPayment}
            path="/wb"
          />

          <PublicRoute
            restricted={false}
            hideNavBarMenus={true}
            component={QuickBuyWBConfirmation}
            path="/qbWBconfirmation"
          />

          {/* <PublicRoute restricted={false} component={SessionExpired} path="/sessionExpired" /> */}

          {/*POST login  */}
          {/* <PrivateRoute restricted={true} hideSidebar={true} component={Onboarding} path="/onboarding/:id" /> */}
          <PublicRoute
            restricted={false}
            exact
            component={PreloginToPostloginSignzyConnector}
            path="/prelogin-to-postlogin-signzy-connector"
          />
          <PrivateRoute
            restricted={true}
            exact
            component={PreloginToPostloginConnector}
            path="/prelogin-to-postlogin-connector"
          />
          <PublicRoute
            restricted={false}
            component={mandatePopup}
            path="/mandatePopup"
          />

          <PrivateRoute
            restricted={true}
            exact
            component={DashboardNew}
            path="/portfolio"
          />
          <PrivateRoute
            restricted={true}
            component={Intersistial}
            path="/dashboard/Intersistial"
          />
          <PrivateRoute
            restricted={true}
            component={TrackOrder}
            path="/orderbook"
          />
          <PrivateRoute
            restricted={true}
            strict
            component={Profile}
            path="/profile"
          />
          <PrivateRoute
            restricted={true}
            strict
            component={OtpPreference}
            path="/otp-preference"
          />
          <PrivateRoute
            restricted={true}
            exact
            component={Connect}
            path="/contact-us"
          />
          <PrivateRoute
            restricted={true}
            strict
            component={PaymentOLResp}
            path="/dashboard/paymentResponse"
          />
          <PrivateRoute
            restricted={true}
            transactType
            component={Transasct}
            path="/transact/:id"
          />
          <PrivateRoute
            restricted={true}
            component={TransResponse}
            path="/dashboard/transResp/:id"
          />
          <PrivateRoute
            restricted={true}
            component={Reports}
            path="/reports/:id"
          />
          <PrivateRoute
            restricted={true}
            component={ManageAc}
            path="/manage-account/:id"
          />
          <PrivateRoute
            restricted={true}
            component={EmandateScreen}
            path="/emandate"
          />
          <PrivateRoute
            restricted={true}
            component={ScheduleSip}
            path="/schedule-investments/sip"
          />
          <PrivateRoute
            restricted={true}
            component={ScheduleSwp}
            path="/schedule-investments/swp"
          />
          <PrivateRoute
            restricted={true}
            component={ScheduleStp}
            path="/schedule-investments/stp"
          />

          <PrivateRoute
            restricted={true}
            component={RedeemThank}
            path="/dashboard/transRes"
          />
          <PrivateRoute
            restricted={true}
            component={Confirmation}
            path="/dashboard/confirmation"
          />
          <PrivateRoute
            restricted={true}
            component={Payment}
            path="/dashboard/Payment"
          />
          <PrivateRoute
            restricted={true}
            hideHeader={true}
            component={CartNew}
            path="/Cart"
          />
          {/* <PrivateRoute restricted={true} component={CartNew} path="/dashboard/CartNew" /> */}

          <PrivateRoute
            restricted={true}
            component={RedeemThank}
            path="/dashboard/transRes"
          />
          <PrivateRoute
            restricted={true}
            component={Confirmation}
            path="/dashboard/confirmation"
          />
          <PrivateRoute
            restricted={true}
            component={Payment}
            path="/dashboard/Payment"
          />
          <PrivateRoute
            restricted={true}
            component={Cart}
            path="/dashboard/Cart"
          />
          <PrivateRoute
            restricted={true}
            component={remuneration}
            path="/remunerations"
          />
          <PrivateRoute
            restricted={true}
            component={addnominee}
            path="/nomineemanage"
          />
          {/* <PrivateRoute
            restricted={true}
            component={addnominee}
            path="/addnominee"
          /> */}
          <PrivateRoute
            restricted={true}
            component={EmandateConfirmation}
            path="/emandateConfirmation"
          />

          {!quickbuyRout ? (
            <PrivateRoute
              restricted={true}
              hideSidebar={true}
              component={Onboarding}
              path="/onboarding/:id"
            />
          ) : (
            <QuickBuyRoute
              restricted={false}
              hideSidebar={true}
              component={Onboarding}
              path="/onboarding/:id"
            />
          )}
          <QuickBuyRoute
            restricted={false}
            hideSidebar={true}
            component={QuickBuy2}
            path="/quickbuy"
          />
          <QuickBuyRoute
            restricted={false}
            hideSidebar={true}
            component={QuickBuyConfirmation}
            path="/qbconfirmation"
          />

          {/* <PrivateRoute restricted={true} hideSidebar={true} component={FabPlanConfirmation} path="/fab-plan/confirmation" /> */}
          <PrivateRoute
            restricted={true}
            component={FabPlan}
            path="/fab-plan/:id"
          />

          <QuickBuyRoute
            restricted={false}
            sipHouse={true}
            component={SipHouse}
            path="/sip/:id"
          />

          {/* <QuickBuyRoute restricted={false} component={NfoBasket} path="/nfobasket" /> */}

          <PrivateRoute
            restricted={false}
            exact
            component={PaymentPage}
            // component={(props) => (
            //   <SipProvider>
            //     <PaymentPage {...props} />
            //   </SipProvider>
            // )}
            path="/payment"
          />

          <PrivateRoute
            restricted={true}
            exact
            hideSidebar={true}
            component={ThankyouPage}
            path="/thankyou"
          />



          {/* <Route strict path={`${this.props.path} /manageaccount/:id`}
          render={({ match }) => <ManageAc manageAc={match.params.id} />}
                    /> */}

          {/* <Route strict path={`${this.props.path}/manageaccount/:id`}
                        render={({ match }) => <ManageAc manageAc={match.params.id} />}
                    /> */}

          {/* <Route strict path={`${this.props.path}/transact/:id`}
                        render={({ match }) => <Transasct transactType={match.params.id} />}
                    />
                    <Route strict path={`${this.props.path}/transResp/:id`}
                        render={({ match }) => <TransResponse transactType={match.params.id} />}
                    /> */}

          <ReedumptionRoute
            restricted={false}
            component={InvestOnline}
            path="/ri/login"
          />
          <ReedumptionRoute
            restricted={false}
            component={CancelRedemption}
            path="/cancelRedemption"
          />
          <ReedumptionRoute
            restricted={false}
            component={RedemptionConfirmation}
            path="/confirmation"
          />
          <PrivateRoute
            restricted={true}
            component={LasDisclaimer}
            path="/las"
          />

          <Route path="/newinvestorapp-txn-feedback">
            <NewInvestorTxnFeedback />
          </Route>
          <PublicRoute
            restricted={false}
            component={Unclaimed}
            path="/unclaimed/login"
          />

          <PublicRoute
            restricted={false}
            component={UnclaimedDashboard}
            path="/unclaimed/dashboard"
          />

          <Route path="/sessionExpired">
            <SessionExpired />
          </Route>
          <Route path="/somethingWentWrong">
            <SomethingWentWrong />
          </Route>
          <Route>
            <NoMatch />
          </Route>
        </Switch>
      </React.Fragment>
    );
  }
}

export default process.env.NODE_ENV === "development"
  ? withRouter(hot(Router))
  : withRouter(Router);
